import { useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Görsel", testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Sadece resim dosyası yükleyebilirsiniz");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Dosya boyutu 10MB'ı geçemez");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      const url = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      onChange(url);
      toast.success("Yüklendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Yükleme başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-xs uppercase tracking-wider text-[#6b655c] block">{label}</label>
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="" className="w-32 h-32 object-cover border border-[#eae5dc]" />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 bg-[#1a1a1a] text-white rounded-full p-1 hover:bg-red-600 transition-colors"
            aria-label="Görseli kaldır"
            data-testid={`${testid}-remove`}
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <label
          className={`flex flex-col items-center justify-center w-32 h-32 border-2 border-dashed border-[#eae5dc] hover:border-[#c8a97e] transition-colors ${busy ? "opacity-50" : "cursor-pointer"}`}
          data-testid={testid}
        >
          {busy ? (
            <Loader2 size={20} className="animate-spin text-[#c8a97e]" />
          ) : (
            <>
              <Upload size={20} className="text-[#6b655c]" />
              <span className="text-xs text-[#6b655c] mt-2">Resim Yükle</span>
            </>
          )}
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={upload}
            disabled={busy}
          />
        </label>
      )}
    </div>
  );
}
